import React from 'react';
import styles from './styles.scss';
import { Icons } from '@densityco/ui';

import Tooltip from '../Tooltip';
import ListViewTwoRowHeader from '../ListViewTwoRowHeader';

const ListViewLearnMoreHeader: React.FunctionComponent<{header: React.ReactNode, tooltip: React.ReactNode}> = (props) => (
  <Tooltip
    target={
      <ListViewTwoRowHeader
        header={props.header}
        subheader={
          <div className={styles.learnMore}>
            Learn more
            <div className={styles.info}>
              <Icons.Info
                width={12}
                height={12}
                color="currentColor"
              />
            </div>
          </div>
        }
      />
    }
    contents={props.tooltip}
  />
);

export default ListViewLearnMoreHeader;
